import React from 'react'
import MediaQuery from 'react-responsive'

import { AcornsIcon } from '@acorns/icons'
import { Heading } from '@acorns/web-components'
import styled from 'styled-components'

import useWindowDimensions from 'hooks/useWindowDimensions'
import themeValues, { style } from 'theme'

import { StyledBody, StyledCard, StyledCloseAccountButton } from '../components'
import { MergedProps } from './index'

const BodyContainer = styled.div`
  padding-bottom: 50px;
  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    height: auto;
    min-height: 50%;
    align-self: center;
    padding-top: 50px;
  }
`
const ButtonContainer = styled.div`
  border-top: 1px solid rgb(245, 245, 245);

  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    border-top: none;
    position: relative;
    width: 100%;
  }
`

const Footnote = styled.div`
  font-size: 12px;
  font-weight: normal;
  height: 16px;
  letter-spacing: 0px;
  line-height: 16px;
  text-align: center;
  margin-bottom: 50px;
  margin-top: 30px;
  color: ${style((theme) => theme.colors.stone)};
  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    margin-bottom: 0px;
    margin-top: 0;
  }
`
const Card = styled(StyledCard)<{ innerHeight?: number }>`
  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    display: flex;
    justify-content: space-between;
    height: ${(props) => `calc(${props.innerHeight}px - 78px)`};
  }
`
const WVCard = styled(StyledCard)<{ innerHeight?: number }>`
  height: ${(props) => `calc(${props.innerHeight}px - 80px)`};
  &&& {
    border-radius: 0;
  }
`

const StyledButton = styled(StyledCloseAccountButton)`
  margin-top: 50px;
  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    margin-top: 20px;
  }
`
const StyledHeading = styled(Heading)`
  font-size: 22px;
  font-weight: 600;
  line-height: 30px;
  text-align: center;
`

const Body = styled(StyledBody)`
  margin: 0 auto;
`

export const ConfirmationScreen: React.FC<MergedProps> = ({
  handleDone,
  laterBalance,
  isWebView,
}) => {
  const CardComponent = isWebView ? WVCard : Card
  const { height } = useWindowDimensions()
  return (
    <>
      {laterBalance ? (
        <CardComponent innerHeight={isWebView ? height : null}>
          <BodyContainer>
            <AcornsIcon
              icon={AcornsIcon.Icon.AcornsPending}
              width="104px"
              height="104px"
              style={{ display: 'block', margin: '0 auto' }}
            />
            <StyledHeading>Closure in progress</StyledHeading>
            <Body>
              We've started the transfer and begun the process of closing your
              Later account. We'll let you know as soon as everything is done.
            </Body>
            <MediaQuery minWidth={themeValues.breakpoints.sm}>
              <Footnote>
                Transfers may take up to 3-6 business days to settle.
              </Footnote>
            </MediaQuery>
          </BodyContainer>
          <ButtonContainer>
            <MediaQuery maxWidth={themeValues.breakpoints.sm - 1}>
              <Footnote>
                Transfers may take up to 3-6 business days to settle.
              </Footnote>
            </MediaQuery>
            <StyledButton onClick={handleDone}>Done</StyledButton>
          </ButtonContainer>
        </CardComponent>
      ) : (
        <CardComponent innerHeight={isWebView ? height : null}>
          <BodyContainer>
            <AcornsIcon
              icon={AcornsIcon.Icon.AcornsPending}
              width="104px"
              height="104px"
              style={{ display: 'block', margin: '0 auto' }}
            />
            <StyledHeading>Closure in progress</StyledHeading>
            <StyledBody>
              We'll start processing your request and let you know as soon as
              your Later account is closed.
            </StyledBody>
          </BodyContainer>
          <StyledCloseAccountButton onClick={handleDone}>
            Done
          </StyledCloseAccountButton>
        </CardComponent>
      )}
    </>
  )
}
